import React from 'react'

import LockIcon from 'images/inline/lock-new.svg'

/*
    LockedStep is almost identical to StartSlide
    if you make changes here, check there also

    TO DO: use new step background component (step3), remove Htmlfooter passed as prop (needed for step1 structure)
*/

const LockedStep = ({ backgroundColor, backgroundImageId, HtmlFooter }) => {
  let style = {}

  if (backgroundColor) {
    style.backgroundColor = backgroundColor
  }

  if (backgroundImageId) {
    style.backgroundImage = `url(${process.env.SITE_ASSET_URL}/${backgroundImageId})`
  }

  return (
    <div className="step-locked" style={style}>
      <div className="container">
        <div className="content">
          <div>
            <LockIcon />
          </div>
          <h2>You haven’t unlocked this step yet!</h2>
          <p>
            Trying to jump ahead, are we? One thing at a time! You haven’t
            unlocked this step just yet. Go back to the step where you left
            off—don’t worry, this will still be here later.
          </p>
        </div>
      </div>
      {HtmlFooter && <HtmlFooter />}
    </div>
  )
}

export default LockedStep
